<template>
  <div class="main-container">
    <div class="bread">
      <router-link :to="{ name: 'MemberHomeworkIndex' }">我的作业</router-link>
      <span class="slash">/</span>
      <span class="current">查看详情</span>
    </div>
    <div class="main-content clearfix">
      <div class="f-left">
        <div class="homework-wrap">
          <div class="homework-name">{{ scantron.hw_name }}</div>
          <div class="info">
            <template v-if="scantron.hw_status != 4">
              <div class="row">
                <div class="cell">
                  <span class="label">作答时长：</span>
                  <span class="text">
                    {{
                      scantron.answer_time > 60
                        ? parseInt(scantron.answer_time / 60) +
                          "分钟" +
                          (scantron.answer_time % 60 > 0
                            ? (scantron.answer_time % 60) + "秒"
                            : "")
                        : scantron.answer_time + "秒"
                    }}
                  </span>
                </div>
                <div class="cell">
                  <span class="label">题目总数：</span>
                  <span class="text">{{ scantron.ques_count }}道</span>
                </div>
                <div class="cell">
                  <span class="label">完成率：</span>
                  <span class="text">{{ scantron.completion_rate }}%</span>
                </div>
                <div class="cell">
                  <span class="label">提交时间：</span>
                  <span class="text">
                    {{
                      scantron.submit_time || scantron.updated_at | tsFormatLong
                    }}
                  </span>
                </div>
              </div>
              <div class="row">
                <template v-if="scantron.is_set_score == 2">
                  <div class="cell">
                    <span class="label">作业总分：</span>
                    <span class="text">{{ scantron.score }}</span>
                  </div>
                  <div class="cell">
                    <span class="label">客观题得分：</span>
                    <span class="text">{{ scantron.objective_score }}</span>
                  </div>
                  <div class="cell">
                    <span class="label">主观题得分：</span>
                    <span class="text">
                      {{
                        scantron.hw_status == 2 ||
                        scantron.data.filter(q => q.ques_type == 5).length == 0
                          ? "-"
                          : scantron.subjective_score
                      }}
                    </span>
                  </div>
                  <template v-if="scantron.hw_status == 3">
                    <div class="cell">
                      <span class="label">最高分：</span>
                      <span class="text">{{ scantron.max_score }}</span>
                    </div>
                    <div class="cell" style="margin-left: 5px">
                      <span class="label">平均分：</span>
                      <span class="text">{{ scantron.ave_score }}</span>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <template v-if="scantron.hw_status == 3">
                    <div class="cell">
                      <span class="label">正确率：</span>
                      <span class="text">{{ scantron.total_score }}%</span>
                    </div>
                    <template v-if="scantron.hw_type != 2">
                      <div class="cell">
                        <span class="label">最高正确率：</span>
                        <span class="text">{{ scantron.max_score }}</span>
                      </div>
                      <div class="cell">
                        <span class="label">平均正确率：</span>
                        <span class="text">{{ scantron.ave_score }}</span>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div class="cell">
                      <span class="label">正确率：</span>
                      <span class="text">待批改</span>
                    </div>
                    <template v-if="scantron.hw_type != 2">
                      <div class="cell">
                        <span class="label">最高正确率：</span>
                        <span class="text">统计中</span>
                      </div>
                      <div class="cell">
                        <span class="label">平均正确率：</span>
                        <span class="text">统计中</span>
                      </div>
                    </template>
                  </template>
                </template>
              </div>
              <div
                class="row comment"
                v-if="scantron.hw_status == 3 && scantron.comment"
              >
                <div class="cell">
                  <span class="label">老师评语：</span>
                  <span class="text">{{ scantron.comment }}</span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="row">
                <div class="cell" style="width: 270px">
                  <span class="label">截止时间：</span>
                  <span class="text">
                    {{ scantron.end_time | tsFormatLong }}
                  </span>
                </div>
                <div class="cell">
                  <span class="label">题目总数：</span>
                  <span class="text">{{ scantron.ques_count }}道</span>
                </div>
                <div class="cell">
                  <span class="label">作业总分：</span>
                  <span class="text">
                    {{ scantron.is_set_score == 2 ? scantron.score : "-" }}
                  </span>
                </div>
              </div>
            </template>
          </div>
          <div
            class="user-score"
            v-if="scantron.hw_status == 3 && scantron.is_set_score == 2"
          >
            {{ scantron.total_score }}
          </div>
        </div>
        <template v-for="ques in list">
          <Question
            :class="{
              'question-sub-first': ques.parent_ques_stem && ques.is_sub_first,
              'question-sub-last': ques.parent_ques_stem && ques.is_sub_last,
              'question-sub': ques.parent_ques_stem,
            }"
            :isFile="2"
            :key="ques.question_id"
            :ques="ques"
            :answer="answer"
            :readonly="true"
            :hasAnalysis="true"
            :showOperate="false"
            from="analysis"
            :showAllParentStem="false"
            :showPoint="false"
            :showAnalysisBtn="false"
            :showAccuracy="false"
            :showScore="scantron.is_set_score == 2"
            :hasReview="scantron.hw_status == 3"
            shotAnswerEditable
            :autoMathJax="false"
          ></Question>
        </template>
      </div>
      <div
        class="f-right"
        :style="{
          position: fixed ? 'fixed' : 'static',
          right: fixedRight + 'px',
          top: '70px',
        }"
      >
        <div class="answer-view">
          <div class="title">答题卡</div>
          <div class="legend">
            <span class="item">
              <span class="num num-1"></span>
              <span class="text">
                正确({{ scantron.data.filter(q => q.status == 1).length }})
              </span>
            </span>
            <span class="item">
              <span class="num num-2"></span>
              <span class="text">
                错误({{ scantron.data.filter(q => q.status == 2).length }})
              </span>
            </span>
            <span class="item">
              <template v-if="scantron.hw_status == 3">
                <span class="num num-5"></span>
                <span class="text">
                  已批改({{ scantron.data.filter(q => q.status == 5).length }})
                </span>
              </template>
              <template v-else>
                <span class="num num-4"></span>
                <span class="text">
                  待批改({{ scantron.data.filter(q => q.status == 4).length }})
                </span>
              </template>
            </span>
            <span class="item">
              <span class="num num-3"></span>
              <span class="text">
                未作答({{ scantron.data.filter(q => q.status == 3).length }})
              </span>
            </span>
          </div>
          <div class="nums">
            <a
              href="javascript:void(0)"
              class="num"
              :class="'num-' + ques.status"
              :key="ques.sort"
              v-for="ques in scantron.data"
              @click="scrollTo(ques.sort)"
            >
              {{ ques.sort }}
            </a>
          </div>
        </div>
        <div class="btn-retry" @click="goBack">返回</div>
      </div>
    </div>
  </div>
</template>
<script>
import Question from "@/components/ques/Question";
export default {
  name: "HomeworkAnalysis",
  components: {
    Question,
  },
  data() {
    return {
      id: this.$route.query.id,
      list: [],
      answer: {},
      fixed: false,
      fixedRight: 0,
      scantron: { list: [] },
    };
  },
  watch: {
    list() {
      this.$nextTick(() => {
        window.MathJax.typesetPromise();
      });
    },
  },
  async created() {
    this.scantron = await this.$http.post("/api/app/user/homework/scantron", {
      report_id: this.$route.query.id,
    });
    let data = await this.$http.post("/api/app/user/homework/question", {
      report_id: this.id,
    });
    let parent_id = "";
    console.log(data);
    data.forEach((ques, index) => {
      if (ques.parent_id != parent_id) {
        parent_id = ques.parent_id;
        ques.is_sub_first = true;
        if (index > 0) {
          data[index - 1].is_sub_last = true;
        }
      }
      ques.attachments.forEach(
        item => (item.ext = this.$actionTool.getFileType(item.name)),
      );
      ques.question_id = ques.ques_id;
      ques.index = index + 1;
      if (ques.ques_type != 5 && typeof ques.ques_option === "string") {
        ques.ques_option = JSON.parse(ques.ques_option);
      }
      if (ques.ques_type == 1 || ques.ques_type == 2) {
        let id = ques.ques_option.filter(o => o.is_right == 1)[0].id;
        this.$set(this.answer, ques.question_id, id);
      } else if (ques.ques_type == 3 || ques.ques_type == 4) {
        let ids = [];
        ques.ques_option
          .filter(o => o.is_right == 1)
          .forEach(o => {
            ids.push(o.id);
          });
        this.$set(this.answer, ques.question_id, ids);
      }
    });
    this.list = data;
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener("scroll", this.setFixed);
      document.addEventListener("resize", this.setFixed);
    });
  },
  destroyed() {
    document.removeEventListener("scroll", this.setFixed);
    document.removeEventListener("resize", this.setFixed);
  },
  methods: {
    setFixed() {
      let $ = window.$;
      if ($(window).scrollTop() > 48) {
        this.fixed = true;
        this.fixedRight = ($(window).width() - 1200) / 2;
        if (this.fixedRight < 0) {
          this.fixedRight = 0;
        }
      } else {
        this.fixed = false;
      }
    },
    scrollTo(id) {
      let $ = window.$;
      let top = $("#" + id).offset().top - 84;
      $(window).scrollTop(top);
    },
    goBack() {
      this.$router.push({ name: "MemberHomeworkIndex" });
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  margin-bottom: 50px;
  .f-left {
    width: 890px;
  }
  .f-right {
    width: 290px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
  }

  /deep/ {
    .question {
      border: none;
      border-radius: 5px;
      background-color: white;
      padding: 18px 34px 0 56px;
      margin-bottom: 10px;
    }
    .question-sub:not(.question-sub-last) {
      margin-bottom: 0 !important;
    }
    .question-sub:not(.question-sub-first) {
      padding-top: 0 !important;
    }
    .degree-wrap {
      margin-bottom: 30px !important;
    }
    .parent-stem {
      background-color: #ededed;
      padding: 0;
      padding-left: 0 !important;
      border: 1px solid rgba(237, 237, 237, 1);
      margin-bottom: 10px;

      .stem {
        padding: 12px;
      }
    }
  }
}
.btn-retry {
  margin: 20px;
  height: 36px;
  background: $primary-color;
  border-radius: 5px;
  font-size: 14px;
  color: white;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  &:hover {
    background: $primary-color-hover;
  }
}
.homework-wrap {
  border-radius: 5px 5px 0 0;
  background-color: white;
  overflow: hidden;
  padding: 0 30px;
  position: relative;
  .homework-name {
    font-size: 18px;
    font-weight: 500;
    line-height: 1;
    text-align: center;
    margin: 31px 0 28px 0;
  }
  .info {
    font-size: 14px;
    line-height: 1;
    overflow: hidden;
  }
  .row,
  .cell {
    display: flex;
  }
  .row {
    padding-bottom: 22px;

    .cell {
      &:nth-child(1),
      &:nth-child(2) {
        width: 170px;
      }
      &:nth-child(3) {
        width: 162px;
      }
    }

    &:last-child {
      padding-bottom: 27px;
      border-bottom: 1px dashed #dbdbdb;
    }

    &.comment {
      .cell {
        width: auto;
        line-height: normal;
      }
    }
  }
  .label {
    color: #999999;
    flex-shrink: 0;
  }
  .user-score {
    position: absolute;
    z-index: 1;
    width: 58px;
    background-image: url("~@/assets/images/homework/score-line@2x.png");
    background-size: 58px 18px;
    background-repeat: no-repeat;
    background-position: bottom center;
    top: 33px;
    right: 34px;
    font-size: 36px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 0, 0, 1);
    line-height: 28px;
    padding: 0 0 26px 3px;
  }
}
.answer-view {
  border: 1px solid rgba(233, 236, 236, 1);
  border-radius: 5px;
  margin: 19px 20px;
  .title {
    height: 40px;
    background: rgba(245, 245, 245, 1);
    line-height: 40px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    padding-left: 18px;
  }
  .nums {
    padding-left: 14px;
    max-height: calc(100vh - 70px - 48px - 19px - 40px - 85px - 56px);
    overflow-y: auto;
    .num {
      &:nth-child(5n) {
        margin-right: 0;
      }
    }
  }
  .num {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    line-height: 28px;
    display: inline-block;
    text-align: center;
    border: 1px solid rgba(191, 191, 191, 1);
    border-radius: 3px;
    color: #333333;
    margin-bottom: 15px;
    margin-right: 13px;
    cursor: pointer;
    &.num-1 {
      background-color: #30c596;
      border-color: #30c596;
      color: white;
    }
    &.num-2 {
      background-color: #ff2d28;
      border-color: #ff2d28;
      color: white;
    }
    &.num-3:hover {
      border-color: #bb1c20;
      color: #bb1c20;
    }
    &.num-4 {
      background-color: #f8d15e;
      border-color: #f8d15e;
      color: white;
    }
    &.num-5 {
      background-color: #3e8ff7;
      border-color: #3e8ff7;
      color: white;
    }
  }
  .legend {
    display: flex;
    flex-wrap: wrap;
    padding: 21px 15px 6px 14px;
    align-items: center;
    .item {
      width: 50%;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
    }
    .num {
      margin-right: 5px;
      width: 14px;
      height: 14px;
      border-radius: 2px;
      cursor: default;
      margin-bottom: 0;
    }
    .text {
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      line-height: 1;
      white-space: nowrap;
    }
  }
}
</style>
